export function openGameHelp() {
  const url = `${window.location.origin}/help/`;
  window.open(url, "_blank", "noopener,noreferrer");
}
